// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".GetAppDialog__acrobatIcon___3rVuW{border-radius:6px;height:40px;opacity:1;width:40px}.GetAppDialog__getAppContainer___ReRnx{display:flex;flex-direction:row;padding-bottom:15px}.GetAppDialog__getAppSubHeading___s8KAc{color:var(--spectrum-global-color-gray-900);font:normal normal 700 15px/19px Adobe Clean,sans-serif;letter-spacing:0;opacity:1;padding-left:10px;padding-top:8px}.GetAppDialog__getAppDescription___bXACA{font:normal normal normal 15px/23px Adobe Clean,sans-serif;letter-spacing:0;opacity:1;text-align:left}", ""]);
// Exports
exports.locals = {
	"acrobatIcon": "GetAppDialog__acrobatIcon___3rVuW",
	"getAppContainer": "GetAppDialog__getAppContainer___ReRnx",
	"getAppSubHeading": "GetAppDialog__getAppSubHeading___s8KAc",
	"getAppDescription": "GetAppDialog__getAppDescription___bXACA"
};
module.exports = exports;
